import React from 'react';
import { FaceScanGuard } from '../../../components/IntelliProve/FaceScanGuard';
import { HealthDashboard } from '../../../components/IntelliProve/HealthDashboard';


export default function HealthDashboardScreen() {
  return (
    <FaceScanGuard>
      <HealthDashboard />
    </FaceScanGuard>
  );
}
